import { useMemo } from 'react';

import { GetAllSites } from '@/api/fe-api/view/queries/get-all-sites';
import { FieldSelect } from '@/components/looker/field-select';
import { useMe } from '@/hooks/use-me';
import type { Group } from '@/task-manager/entities/group';
import { siteId } from '@/utils/format/customer';
import { singular } from '@/utils/format/label';

export type GroupFilterProps = {
  value?: string;
  onChange: (value?: string) => void;
};

export function GroupFilter({ value, onChange }: GroupFilterProps) {
  const me = useMe();
  const listGroups = GetAllSites.useQuery();

  const selectedGroup = useMemo<Group | undefined>(
    () =>
      listGroups.data?.find(({ fullFrontendId }) => fullFrontendId === value) ??
      undefined,
    [value, listGroups.data],
  );

  return (
    <FieldSelect
      data-testid="group-filter"
      label={singular(me.config.group.labels.name)}
      placeholder={`Filter by ${singular(me.config.group.labels.name)}`}
      value={selectedGroup?.name}
      options={
        listGroups.data?.map(({ fullFrontendId }) => ({
          value: fullFrontendId,
        })) ?? []
      }
      onChange={(name) => onChange(name !== '' ? siteId(name) : undefined)}
      isFilterable={true}
      isClearable={true}
    />
  );
}
